// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `    .home-page {
        min-height: 1400;

        padding-top: 50px;
    }

    ul {
        list-style-type: disc;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        font-family: 'Avenir Light', sans-serif;
    }

    li {
        justify-content: start;
        font-family: 'Avenir Light', sans-serif;
        text-align: left;
    }

    .video-Container {
        padding-top: 60px;
        display: flex;
        flex-wrap: wrap;
        /* gap: 80px; */
        /* justify-content: center; */
        max-width: 940px !important;
        position: relative;
        z-index: 1;


    }

    .video-Container video {
        border-radius: 5px;
    }


    .select-form-input {
        width: 100%;
        padding: 10px;
        margin-bottom: 10px;
        box-sizing: border-box;
        border: 1px solid #ccc;
        border-radius: 4px;
        font-size: 16px;
        background-color: white;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
      }

      .forgot-password{
        margin-top: 10px;
      }


      .birthdate{
        display: flex;
        margin-bottom: 5px;
      }




    .education-page {
        /* height: 900px !important; */
    }

    .amplify-button {
        background-color: #Ff3131;
        color: rgb(31, 31, 31);
    }

    /* .amplify-tabs-item:hover {
        color: #ff3131;
        border-color: #ff3131;
    }

    .amplify-tabs-item:active {
        color: #ff3131;
        border-color: #ff3131;
    } */

    .auth-block {

        margin-top: 0 !important;
        width: auto;
        padding-top: 50px;

    }

    .amplify-button {
        color: #FF3131;
    }



    .default-div {
        max-width: 800px;

        margin: 0 auto;

        padding: 20px;

        font-family: 'Avenir', sans-serif;
        /* Choose a suitable font */

        /* Adjust the font size as needed */
        line-height: 1.5;
        /* Set the line height for better readability */
        color: #3b3b3b;
        /* Set the text color */
        background-color: #f8f8f8dd;
        /* Set a light background color */
        border-radius: 8px;
        /* Add rounded corners */

        /* Add a subtle box shadow */
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
        margin-top: 50px;
        margin-bottom: 50px;
    }

    @media screen and (max-width: 600px) {
        .default-div {
            max-width: 100vh;

            margin: 0 auto;

            padding: 20px;

            font-family: 'Arial', sans-serif;
            /* Choose a suitable font */

            /* Adjust the font size as needed */
            line-height: 1.5;
            /* Set the line height for better readability */
            color: #333;
            /* Set the text color */
            background-color: #f8f8f8dd;
            /* Set a light background color */
            border-radius: 8px;
            /* Add rounded corners */
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
            /* Add a subtle box shadow */

            margin-top: 50px;
            margin-left: 10px;
            margin-right: 10px;
            margin-bottom: 20px;
        }

    }

    .home-page-authenticator {
        padding-bottom: 50px;
        padding-top: 50px;
    }

    .data-amplify-authenticator {}

    .logout-btn {
        display: flex;
        justify-content: right;
        padding-right: 15px;
        padding-top: 10px;
    }

    /* .gap-container {
        
        max-width: 400px;
        min-height: 800px;
    } */`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"IAAI;QACI,gBAAgB;;QAEhB,iBAAiB;IACrB;;IAEA;QACI,qBAAqB;QACrB,aAAa;QACb,sBAAsB;QACtB,2BAA2B;QAC3B,uBAAuB;QACvB,uCAAuC;IAC3C;;IAEA;QACI,sBAAsB;QACtB,uCAAuC;QACvC,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,eAAe;QACf,eAAe;QACf,6BAA6B;QAC7B,2BAA2B;QAC3B,kBAAkB;QAClB,UAAU;;;IAGd;;IAEA;QACI,kBAAkB;IACtB;;;IAGA;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,sBAAsB;QACtB,sBAAsB;QACtB,kBAAkB;QAClB,eAAe;QACf,uBAAuB;QACvB,gBAAgB;QAChB,wBAAwB;QACxB,qBAAqB;MACvB;;MAEA;QACE,gBAAgB;MAClB;;;MAGA;QACE,aAAa;QACb,kBAAkB;MACpB;;;;;IAKF;QACI,8BAA8B;IAClC;;IAEA;QACI,yBAAyB;QACzB,sBAAsB;IAC1B;;IAEA;;;;;;;;OAQG;;IAEH;;QAEI,wBAAwB;QACxB,WAAW;QACX,iBAAiB;;IAErB;;IAEA;QACI,cAAc;IAClB;;;;IAIA;QACI,gBAAgB;;QAEhB,cAAc;;QAEd,aAAa;;QAEb,iCAAiC;QACjC,2BAA2B;;QAE3B,mCAAmC;QACnC,gBAAgB;QAChB,+CAA+C;QAC/C,cAAc;QACd,uBAAuB;QACvB,2BAA2B;QAC3B,iCAAiC;QACjC,kBAAkB;QAClB,wBAAwB;;QAExB,4BAA4B;QAC5B,uCAAuC;QACvC,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI;YACI,gBAAgB;;YAEhB,cAAc;;YAEd,aAAa;;YAEb,gCAAgC;YAChC,2BAA2B;;YAE3B,mCAAmC;YACnC,gBAAgB;YAChB,+CAA+C;YAC/C,WAAW;YACX,uBAAuB;YACvB,2BAA2B;YAC3B,iCAAiC;YACjC,kBAAkB;YAClB,wBAAwB;YACxB,uCAAuC;YACvC,4BAA4B;;YAE5B,gBAAgB;YAChB,iBAAiB;YACjB,kBAAkB;YAClB,mBAAmB;QACvB;;IAEJ;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;IACrB;;IAEA,6BAA6B;;IAE7B;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;;;;OAIG","sourcesContent":["    .home-page {\n        min-height: 1400;\n\n        padding-top: 50px;\n    }\n\n    ul {\n        list-style-type: disc;\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-start;\n        align-items: flex-start;\n        font-family: 'Avenir Light', sans-serif;\n    }\n\n    li {\n        justify-content: start;\n        font-family: 'Avenir Light', sans-serif;\n        text-align: left;\n    }\n\n    .video-Container {\n        padding-top: 60px;\n        display: flex;\n        flex-wrap: wrap;\n        /* gap: 80px; */\n        /* justify-content: center; */\n        max-width: 940px !important;\n        position: relative;\n        z-index: 1;\n\n\n    }\n\n    .video-Container video {\n        border-radius: 5px;\n    }\n\n\n    .select-form-input {\n        width: 100%;\n        padding: 10px;\n        margin-bottom: 10px;\n        box-sizing: border-box;\n        border: 1px solid #ccc;\n        border-radius: 4px;\n        font-size: 16px;\n        background-color: white;\n        appearance: none;\n        -webkit-appearance: none;\n        -moz-appearance: none;\n      }\n\n      .forgot-password{\n        margin-top: 10px;\n      }\n\n\n      .birthdate{\n        display: flex;\n        margin-bottom: 5px;\n      }\n\n\n\n\n    .education-page {\n        /* height: 900px !important; */\n    }\n\n    .amplify-button {\n        background-color: #Ff3131;\n        color: rgb(31, 31, 31);\n    }\n\n    /* .amplify-tabs-item:hover {\n        color: #ff3131;\n        border-color: #ff3131;\n    }\n\n    .amplify-tabs-item:active {\n        color: #ff3131;\n        border-color: #ff3131;\n    } */\n\n    .auth-block {\n\n        margin-top: 0 !important;\n        width: auto;\n        padding-top: 50px;\n\n    }\n\n    .amplify-button {\n        color: #FF3131;\n    }\n\n\n\n    .default-div {\n        max-width: 800px;\n\n        margin: 0 auto;\n\n        padding: 20px;\n\n        font-family: 'Avenir', sans-serif;\n        /* Choose a suitable font */\n\n        /* Adjust the font size as needed */\n        line-height: 1.5;\n        /* Set the line height for better readability */\n        color: #3b3b3b;\n        /* Set the text color */\n        background-color: #f8f8f8dd;\n        /* Set a light background color */\n        border-radius: 8px;\n        /* Add rounded corners */\n\n        /* Add a subtle box shadow */\n        box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n        margin-top: 50px;\n        margin-bottom: 50px;\n    }\n\n    @media screen and (max-width: 600px) {\n        .default-div {\n            max-width: 100vh;\n\n            margin: 0 auto;\n\n            padding: 20px;\n\n            font-family: 'Arial', sans-serif;\n            /* Choose a suitable font */\n\n            /* Adjust the font size as needed */\n            line-height: 1.5;\n            /* Set the line height for better readability */\n            color: #333;\n            /* Set the text color */\n            background-color: #f8f8f8dd;\n            /* Set a light background color */\n            border-radius: 8px;\n            /* Add rounded corners */\n            box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n            /* Add a subtle box shadow */\n\n            margin-top: 50px;\n            margin-left: 10px;\n            margin-right: 10px;\n            margin-bottom: 20px;\n        }\n\n    }\n\n    .home-page-authenticator {\n        padding-bottom: 50px;\n        padding-top: 50px;\n    }\n\n    .data-amplify-authenticator {}\n\n    .logout-btn {\n        display: flex;\n        justify-content: right;\n        padding-right: 15px;\n        padding-top: 10px;\n    }\n\n    /* .gap-container {\n        \n        max-width: 400px;\n        min-height: 800px;\n    } */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
